module.exports = __webpack_public_path__ + "img/servier.5e483651.png";